<template>
    <svg
    class="w-4 h-8 mr-2 text-new-primary"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    >
        <title>Back</title>
        <path
            class="heroicon-ui"
            :fill="fill"
            d="M5.41 11H21a1 1 0 0 1 0 2H5.41l5.3 5.3a1 1 0 0 1-1.42 1.4l-7-7a1 1 0 0 1 0-1.4l7-7a1 1 0 0 1 1.42 1.4L5.4 11z"
        />
    </svg>

</template>
<script>
export default {
    props: {
        fill: {
            type: String,
            default:()=>''
        }
    }
}
</script>